import { render, staticRenderFns } from "./BlockOfText.vue?vue&type=template&id=0fc2cef6&scoped=true"
import script from "./BlockOfText.vue?vue&type=script&lang=js"
export * from "./BlockOfText.vue?vue&type=script&lang=js"
import style0 from "./BlockOfText.vue?vue&type=style&index=0&id=0fc2cef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2cef6",
  null
  
)

export default component.exports